import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
let DxNciDictionaryItem = class DxNciDictionaryItem {
    constructor() {
        this._ord = 0;
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get parentId() {
        return this._parentId;
    }
    set parentId(value) {
        this._parentId = value;
    }
    get ident() {
        return this._ident;
    }
    set ident(value) {
        this._ident = value;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get ord() {
        return this._ord;
    }
    set ord(value) {
        this._ord = value;
    }
    get startDate() {
        return this._startDate;
    }
    set startDate(value) {
        this._startDate = value;
    }
    get endDate() {
        return this._endDate;
    }
    set endDate(value) {
        this._endDate = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxNciDictionaryItem.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "parentId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxNciDictionaryItem.prototype, "_parentId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ident", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxNciDictionaryItem.prototype, "_ident", void 0);
tslib_1.__decorate([
    jsonMember({ name: "name", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxNciDictionaryItem.prototype, "_name", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ord", constructor: Number, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxNciDictionaryItem.prototype, "_ord", void 0);
tslib_1.__decorate([
    jsonMember({ name: "startDate", constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], DxNciDictionaryItem.prototype, "_startDate", void 0);
tslib_1.__decorate([
    jsonMember({ name: "endDate", constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], DxNciDictionaryItem.prototype, "_endDate", void 0);
DxNciDictionaryItem = tslib_1.__decorate([
    jsonObject
], DxNciDictionaryItem);
export { DxNciDictionaryItem };
